import { render, staticRenderFns } from "./CapacityPlannerStandalone.vue?vue&type=template&id=5f221478&scoped=true&"
import script from "./CapacityPlannerStandalone.vue?vue&type=script&lang=js&"
export * from "./CapacityPlannerStandalone.vue?vue&type=script&lang=js&"
import style0 from "./CapacityPlannerStandalone.vue?vue&type=style&index=0&id=5f221478&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f221478",
  null
  
)

export default component.exports